import { getApiClient } from '../axios-config';

/**
 * Shop Time Bridge (#243) API service.
 * Exception reads: analytics or admin. Resolve / run / status: admin only.
 */
class ShopSyncAPI {
  /** Latest run summary. */
  static async getStatus(token) {
    const apiClient = getApiClient(token);
    const response = await apiClient.get('/api/admin/shop-sync/status');
    return response.data.run || null;
  }

  /** Exceptions, optionally filtered by resolved flag and/or Fieldtime project id. */
  static async getExceptions(token, { resolved, projectId } = {}) {
    const apiClient = getApiClient(token);
    const params = {};
    if (typeof resolved === 'boolean') params.resolved = resolved;
    if (projectId) params.project_id = projectId;
    const response = await apiClient.get('/api/admin/shop-sync/exceptions', {
      params,
    });
    return response.data.exceptions || [];
  }

  /** Per-project unresolved exception counts: [{ fieldtime_project_id, count }]. */
  static async getExceptionCounts(token) {
    const apiClient = getApiClient(token);
    const response = await apiClient.get(
      '/api/admin/shop-sync/exception-counts'
    );
    return response.data.counts || [];
  }

  /** Mark one exception resolved. */
  static async resolveException(token, id) {
    const apiClient = getApiClient(token);
    const response = await apiClient.post(
      `/api/admin/shop-sync/exceptions/${id}/resolve`
    );
    return response.data.exception || null;
  }

  /**
   * Trigger a sync run (manual / backfill).
   * body: { project_id?, dry_run?, week_ending? | (date_start & date_end)? }
   */
  static async run(token, body = {}) {
    const apiClient = getApiClient(token);
    const response = await apiClient.post('/api/admin/shop-sync/run', body);
    return response.data.result || null;
  }
}

export default ShopSyncAPI;
